(function () {
  if (customElements.get('nova-poshta-picker')) return;

  var API_URL = 'https://api.novaposhta.ua/v2.0/json/';
  var ATTR_CITY = 'Nova Poshta city';
  var ATTR_CITY_REF = '_np_city_ref';
  var ATTR_BRANCH = 'Nova Poshta branch';
  var ATTR_BRANCH_REF = '_np_branch_ref';
  var ATTR_COUNTRY = 'Nova Poshta country';
  var ATTR_COUNTRY_CODE = '_np_country';
  var RESTRICTED = /тільки для/i;
  var CART_API_URL = '/api/2025-10/graphql.json';
  var DELIVERY_ADDRESSES_MUTATION =
    'mutation($cartId: ID!, $addresses: [CartSelectableAddressInput!]!) {' +
    ' cartDeliveryAddressesReplace(cartId: $cartId, addresses: $addresses) { userErrors { message } } }';

  function request(method, props) {
    return fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        apiKey: '',
        modelName: 'AddressGeneral',
        calledMethod: method,
        methodProperties: props
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (!data.success) throw new Error((data.errors || []).join(', '));
        return data.data || [];
      });
  }

  function searchCities(query) {
    return request('searchSettlements', { CityName: query, Limit: '20', Page: '1' }).then(function (data) {
      var addresses = (data[0] && data[0].Addresses) || [];
      return addresses
        .filter(function (city) { return Number(city.Warehouses) > 0 && city.DeliveryCity; })
        .map(function (city) { return { label: city.Present, ref: city.DeliveryCity }; });
    });
  }

  function searchBranches(cityRef, query) {
    return request('getWarehouses', {
      CityRef: cityRef,
      FindByString: query,
      Limit: '50',
      Page: '1',
      Language: 'UA'
    }).then(function (data) {
      return data
        .filter(function (branch) {
          return branch.WarehouseStatus === 'Working' && branch.DenyToSelect !== '1' && (query || !RESTRICTED.test(branch.Description));
        })
        .map(function (branch) {
          return {
            label: branch.Description,
            ref: branch.Ref,
            address: { address1: branch.Description, city: branch.CityDescription, zip: branch.PostalCodeUA }
          };
        });
    });
  }

  function intlRequest(api, path, params) {
    return fetch(api + path + '?' + new URLSearchParams(params).toString())
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (data) { return data.items || []; });
  }

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function updateLocalization(countryCode) {
    var body = new URLSearchParams({
      form_type: 'localization',
      utf8: '\u2713',
      _method: 'put',
      country_code: countryCode,
      return_to: window.location.pathname
    });
    return fetch(routesRoot() + 'localization', { method: 'POST', body: body, redirect: 'manual' });
  }

  function toggleCollapse(element, show) {
    if (!element || element.classList.contains('is-collapsed') === !show) return;
    element.classList.add('is-animating');
    element.classList.toggle('is-collapsed', !show);
    element.setAttribute('aria-hidden', String(!show));
    element.toggleAttribute('inert', !show);
    clearTimeout(element.collapseTimer);
    element.collapseTimer = setTimeout(function () { element.classList.remove('is-animating'); }, 400);
  }

  function saveAttributes(attributes) {
    var root = routesRoot();
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  }

  function saveDeliveryAddress(address) {
    return fetch(routesRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        return fetch(CART_API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            query: DELIVERY_ADDRESSES_MUTATION,
            variables: {
              cartId: 'gid://shopify/Cart/' + cart.token,
              addresses: address ? [{ selected: true, oneTimeUse: true, address: { deliveryAddress: address } }] : []
            }
          })
        });
      })
      .catch(function () {});
  }

  class NovaPoshtaPicker extends HTMLElement {
    connectedCallback() {
      this.cityInput = this.querySelector('[data-np-input="city"]');
      this.branchInput = this.querySelector('[data-np-input="branch"]');
      this.cityList = this.querySelector('[data-np-list="city"]');
      this.branchList = this.querySelector('[data-np-list="branch"]');
      this.message = this.querySelector('[data-np-message]');
      this.fields = this.querySelector('[data-np-fields]');
      this.note = this.querySelector('[data-np-note]');
      this.countryInput = this.querySelector('[data-np-input="country"]');
      this.intl = this.dataset.mode === 'intl';
      this.scope = this.closest('.cart-drawer-delivery, .drawer__footer, .cart__footer') || document;

      this.city = { label: this.cityInput.value, ref: this.dataset.cityRef || '' };
      this.branch = { label: this.branchInput.value, ref: this.dataset.branchRef || '' };

      this.setupCombobox(this.cityInput, this.cityList, this.loadCities.bind(this), this.selectCity.bind(this), 'city');
      this.setupCombobox(this.branchInput, this.branchList, this.loadBranches.bind(this), this.selectBranch.bind(this), 'branch');

      this.addEventListener('change', function (event) { event.stopPropagation(); });

      if (this.countryInput) {
        this.countries = this.readCountries();
        var countryRef = this.dataset.countryRef;
        this.country = this.countries.filter(function (country) { return country.ref === countryRef; })[0] || { label: '', ref: '', np: false };
        this.setupCombobox(this.countryInput, this.querySelector('[data-np-list="country"]'), this.loadCountries.bind(this), this.selectCountry.bind(this), 'country');
        if (this.country.ref && this.country.ref !== this.dataset.localizationCountry) updateLocalization(this.country.ref);
      }

      this.onCheckoutClick = this.onCheckoutClick.bind(this);
      this.scope.addEventListener('click', this.onCheckoutClick, true);
      this.updateCheckout();
    }

    disconnectedCallback() {
      if (this.scope) this.scope.removeEventListener('click', this.onCheckoutClick, true);
    }

    hasPoints() {
      return !this.countryInput || Boolean(this.country.np);
    }

    isComplete() {
      return !this.hasPoints() || Boolean(this.city.ref && this.branch.ref);
    }

    checkoutButtons() {
      return this.scope.querySelectorAll('[name="checkout"]');
    }

    updateCheckout() {
      var complete = this.isComplete();
      this.checkoutButtons().forEach(function (button) {
        button.toggleAttribute('data-np-blocked', !complete);
        button.setAttribute('aria-disabled', String(!complete));
      });
      this.message.hidden = complete;
    }

    persist(save) {
      var self = this;
      var current = (this.saving || Promise.resolve())
        .then(save)
        .catch(function () {})
        .then(function () {
          if (self.saving === current) self.saving = null;
        });
      this.saving = current;
      return current;
    }

    onCheckoutClick(event) {
      var button = event.target.closest('[name="checkout"]');
      if (!button) return;
      if (this.isComplete() && this.saving) {
        event.preventDefault();
        event.stopPropagation();
        this.saving.then(function () { button.click(); });
        return;
      }
      if (this.isComplete()) return;
      event.preventDefault();
      event.stopPropagation();
      this.message.hidden = false;
      this.message.classList.add('nova-poshta__message--error');
      (this.city.ref ? this.branchInput : this.cityInput).focus();
    }

    setupCombobox(input, list, load, select, key) {
      var timer = null;
      var self = this;

      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { self.populate(input, list, load, select); }, 250);
      });

      input.addEventListener('focus', function () {
        if (key !== 'city' || input.value.trim().length >= 2) {
          self.populate(input, list, load, select, key !== 'city' && input.value === self[key].label);
        }
      });

      input.addEventListener('keydown', function (event) {
        var options = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
        var index = options.indexOf(list.querySelector('[aria-selected="true"]'));
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          if (!options.length) return;
          event.preventDefault();
          index = event.key === 'ArrowDown' ? Math.min(index + 1, options.length - 1) : Math.max(index - 1, 0);
          options.forEach(function (option, i) { option.setAttribute('aria-selected', String(i === index)); });
          options[index].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter') {
          if (index > -1) {
            event.preventDefault();
            options[index].click();
          }
        } else if (event.key === 'Escape' && !list.hidden) {
          self.closeList(input, list);
          input.escapeHandled = true;
        }
      });

      input.addEventListener('keyup', function (event) {
        if (event.key === 'Escape' && input.escapeHandled) {
          input.escapeHandled = false;
          event.stopPropagation();
        }
      });

      input.addEventListener('blur', function () {
        setTimeout(function () {
          self.closeList(input, list);
          var current = self[key];
          if (input.value !== current.label) input.value = current.label;
        }, 200);
      });
    }

    populate(input, list, load, select, showAll) {
      var self = this;
      var query = showAll ? '' : input.value.trim();
      var requestId = (list.requestId || 0) + 1;
      list.requestId = requestId;
      this.renderStatus(input, list, this.dataset.textLoading);

      load(query)
        .then(function (items) {
          if (list.requestId !== requestId) return;
          if (!items.length) {
            self.renderStatus(input, list, self.dataset.textNoResults);
            return;
          }
          list.innerHTML = '';
          items.forEach(function (item) {
            var option = document.createElement('li');
            option.className = 'nova-poshta__option';
            option.setAttribute('role', 'option');
            option.setAttribute('aria-selected', 'false');
            option.textContent = item.label;
            option.addEventListener('mousedown', function (event) { event.preventDefault(); });
            option.addEventListener('click', function () {
              self.closeList(input, list);
              select(item);
            });
            list.appendChild(option);
          });
          self.openList(input, list);
        })
        .catch(function () {
          if (list.requestId === requestId) self.renderStatus(input, list, self.dataset.textError);
        });
    }

    renderStatus(input, list, text) {
      list.innerHTML = '';
      var status = document.createElement('li');
      status.className = 'nova-poshta__status';
      status.textContent = text;
      list.appendChild(status);
      this.openList(input, list);
    }

    openList(input, list) {
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    closeList(input, list) {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    loadCities(query) {
      if (query.length < 2) return Promise.resolve([]);
      if (!this.intl) return searchCities(query);
      var ukrainian = /^uk/i.test(document.documentElement.lang);
      return intlRequest(this.dataset.api, '/cities', { country: this.country.ref, q: query }).then(function (items) {
        return items.map(function (city) { return { label: ukrainian ? city.nameUk : city.name, ref: String(city.id), name: city.name }; });
      });
    }

    loadBranches(query) {
      if (!this.city.ref) return Promise.resolve([]);
      if (!this.intl) return searchBranches(this.city.ref, query);
      var types = { branch: this.dataset.textBranch, postomat: this.dataset.textPostomat, pudo: this.dataset.textPudo };
      var cityName = this.city.name || this.city.label;
      return intlRequest(this.dataset.api, '/divisions', { country: this.country.ref, city: this.city.ref, q: query }).then(function (items) {
        return items.map(function (division) {
          var title = (types[division.type] || '') + ' ' + division.number;
          var address = [division.address, division.postCode].filter(Boolean).join(', ');
          return {
            label: title + ': ' + address,
            ref: String(division.id),
            address: { address1: title.trim() + ': ' + division.address, city: cityName, zip: division.postCode }
          };
        });
      });
    }

    readCountries() {
      var source = this.querySelector('[data-np-countries]');
      var collator = new Intl.Collator(document.documentElement.lang || undefined);
      return JSON.parse(source.textContent)
        .map(function (country) { return { label: country.name, ref: country.code, np: Boolean(country.np) }; })
        .sort(function (a, b) { return collator.compare(a.label, b.label); });
    }

    loadCountries(query) {
      var needle = query.toLowerCase();
      return Promise.resolve(this.countries.filter(function (country) {
        return !needle || country.label.toLowerCase().indexOf(needle) > -1 || country.ref.toLowerCase() === needle;
      }));
    }

    countryAttributes(attributes) {
      if (!this.countryInput) {
        attributes[ATTR_COUNTRY] = '';
        attributes[ATTR_COUNTRY_CODE] = 'UA';
        return attributes;
      }
      attributes[ATTR_COUNTRY] = this.country.label;
      attributes[ATTR_COUNTRY_CODE] = this.country.ref;
      return attributes;
    }

    selectCountry(item) {
      this.countryInput.value = item.label;
      if (item.ref === this.country.ref) return;
      this.country = item;
      this.city = { label: '', ref: '' };
      this.branch = { label: '', ref: '' };
      this.cityInput.value = '';
      this.branchInput.value = '';
      this.branchInput.disabled = true;
      toggleCollapse(this.fields, this.hasPoints());
      toggleCollapse(this.note, !this.hasPoints());
      this.message.classList.remove('nova-poshta__message--error');
      this.updateCheckout();

      var attributes = this.countryAttributes({});
      attributes[ATTR_CITY] = '';
      attributes[ATTR_CITY_REF] = '';
      attributes[ATTR_BRANCH] = '';
      attributes[ATTR_BRANCH_REF] = '';
      this.persist(function () {
        return saveAttributes(attributes)
          .then(function () { return updateLocalization(item.ref); })
          .then(function () { return saveDeliveryAddress(null); });
      });
      if (this.hasPoints()) this.cityInput.focus();
    }

    selectCity(item) {
      var changed = item.ref !== this.city.ref;
      this.city = item;
      this.cityInput.value = item.label;
      if (changed) {
        this.branch = { label: '', ref: '' };
        this.branchInput.value = '';
      }
      this.branchInput.disabled = false;
      this.updateCheckout();

      var attributes = this.countryAttributes({});
      attributes[ATTR_CITY] = item.label;
      attributes[ATTR_CITY_REF] = item.ref;
      if (changed) {
        attributes[ATTR_BRANCH] = '';
        attributes[ATTR_BRANCH_REF] = '';
      }
      this.persist(function () {
        return saveAttributes(attributes).then(function () {
          if (changed) return saveDeliveryAddress(null);
        });
      });
      if (changed) this.branchInput.focus();
    }

    selectBranch(item) {
      this.branch = item;
      this.branchInput.value = item.label;
      this.message.classList.remove('nova-poshta__message--error');
      this.updateCheckout();

      var attributes = {};
      attributes[ATTR_BRANCH] = item.label;
      attributes[ATTR_BRANCH_REF] = item.ref;
      var address = item.address
        ? {
            countryCode: this.countryInput ? this.country.ref : 'UA',
            address1: item.address.address1,
            city: item.address.city || this.city.label,
            zip: item.address.zip || ''
          }
        : null;
      this.persist(function () {
        return saveAttributes(attributes).then(function () { return saveDeliveryAddress(address); });
      });
    }
  }

  customElements.define('nova-poshta-picker', NovaPoshtaPicker);
})();
